import { ListHeader } from 'components/molecules/ListHeader';

export const TaskListHeader = () => (
  <ListHeader
    columns={[
      'タスク名',
      '対象バージョン',
      'タスク開始日',
      'タスク終了日',
      'ターゲットグループ',
    ]}
    templateColumns="1fr 3fr 2fr 2fr 2fr"
  />
);
